export const PREMIERE_VISITE_QUESTIONS = [
  'À quelle heure arriver ?',
  "Comment m'habiller ?",
  'Et mes enfants ?',
  'Vais-je devoir prendre la parole ?',
]
